import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import Timesheet from '@/pages/Timesheet';
import Screenshots from '@/pages/Screenshots';
import Reports from '@/pages/Reports';
import Settings from '@/pages/Settings';
import LeaveRequests from '@/pages/LeaveRequests';
import TeamsManagement from '@/pages/TeamsManagement';
import TeamAdmins from '@/pages/TeamAdmins';
import EmployeesManagement from '@/pages/EmployeesManagement';
import TaskManagement from '@/pages/TaskManagement';
import ChangePassword from '@/pages/ChangePassword';
import ProtectedRoute from '@/components/ProtectedRoute';
import AdminRoute from '@/components/AdminRoute';
import SecurityManagerRoute from '@/components/SecurityManagerRoute';
import '@/App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/timesheet" element={<ProtectedRoute><Timesheet /></ProtectedRoute>} />
          <Route path="/screenshots" element={<ProtectedRoute><Screenshots /></ProtectedRoute>} />
          <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
          <Route path="/report-table" element={<Navigate to="/reports?tab=table" replace />} />
          <Route path="/leave-requests" element={<ProtectedRoute><LeaveRequests /></ProtectedRoute>} />
          <Route path="/tasks" element={<ProtectedRoute><TaskManagement /></ProtectedRoute>} />
          <Route path="/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
          <Route path="/employees-management" element={<AdminRoute><EmployeesManagement /></AdminRoute>} />
          <Route path="/settings" element={<AdminRoute><Settings /></AdminRoute>} />
          <Route path="/teams" element={<SecurityManagerRoute><TeamsManagement /></SecurityManagerRoute>} />
          <Route path="/teams/:teamId/admins" element={<SecurityManagerRoute><TeamAdmins /></SecurityManagerRoute>} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;